import unionBy from 'lodash/unionBy'

import { hiddenFormParamTypes } from '../../types'
import { initialHiddenFormParams } from '../initial-state'
import { ReduxAction, reduxTypes } from '../types'

const hiddenFormParamsReducer = (
  previousState: hiddenFormParamTypes.HiddenFormParam[] = initialHiddenFormParams,
  action: ReduxAction<hiddenFormParamTypes.HiddenFormParam[]>,
) => {
  if (action.type === reduxTypes.HIDDEN_FORM_PARAMS_MERGE) {
    return unionBy(action.payload, previousState, 'key')
  }
  return previousState
}

export default hiddenFormParamsReducer
